export default class GeofenceUnitModel {
  constructor(
    geofenceName,
    geofenceDescription,
    geofenceLatitude,
    geofenceLongitude,
    geofenceTag,
    siteId,
    siteName,
    siteCity,
    siteRegion,
    unitExternalId,
    unitId,
    unitName,
    unitLatitude,
    unitLongitude,
    unitDistanceFromCentroid,
    unitWidth,
    unitHeight,
    unitNetwork,
    mediaOwnerName,
    mediaTypeName,
    marketNames,
    unitIABBlock,
    spotLength,
    minSpotLength,
    maxSpotLength,
    allowedLanguages,
  ) {
    this.geofenceName = geofenceName;
    this.geofenceDescription = geofenceDescription;
    this.geofenceLatitude = geofenceLatitude;
    this.geofenceLongitude = geofenceLongitude;
    this.geofenceTag = geofenceTag;
    this.siteId = siteId;
    this.siteName = siteName;
    this.siteCity = siteCity;
    this.siteRegion = siteRegion;
    this.unitExternalId = unitExternalId;
    this.unitId = unitId;
    this.unitName = unitName;
    this.unitLatitude = unitLatitude;
    this.unitLongitude = unitLongitude;
    this.unitDistanceFromCentroid = unitDistanceFromCentroid;
    this.unitWidth = unitWidth;
    this.unitHeight = unitHeight;
    this.unitNetwork = unitNetwork;
    this.mediaOwnerName = mediaOwnerName;
    this.mediaTypeName = mediaTypeName;
    this.marketNames = marketNames;
    this.unitIABBlock = unitIABBlock;
    this.spotLength = spotLength;
    this.minSpotLength = minSpotLength;
    this.maxSpotLength = maxSpotLength;
    this.allowedLanguages = allowedLanguages;
  }

  get radius() {
    if (this.geofenceTag) {
      const tags = JSON.parse(this.geofenceTag);
      if (tags.isPoint) {
        return tags.radius;
      }
    }
    return undefined;
  }
}
